import type { IconData } from '@stacksjs/iconify-core'

export const intersexSymbol: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M43.526 10.65c.789.694 1.851.234 1.971-.81c.202-1.765.413-4.01.48-6.34A1.434 1.434 0 0 0 44.5 2.022a67 67 0 0 0-6.421.51c-1.022.131-1.45 1.175-.766 1.945c.657.74 1.628 1.774 3.053 3.189a74 74 0 0 0 3.16 2.985Z\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M11 23a13 13 0 1 0 26 0a13 13 0 1 0-26 0m32.526-12.35c.789.694 1.851.234 1.971-.81c.202-1.765.413-4.01.48-6.34A1.434 1.434 0 0 0 44.5 2.022a67 67 0 0 0-6.421.51c-1.022.131-1.45 1.175-.766 1.945c.657.74 1.628 1.774 3.053 3.189a74 74 0 0 0 3.16 2.985ZM40 8l-6 6M24 36v10m4-4h-8\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default intersexSymbol
